import { render, staticRenderFns } from "./UserRolesFilter.vue?vue&type=template&id=e71ea706&"
import script from "./UserRolesFilter.vue?vue&type=script&lang=ts&"
export * from "./UserRolesFilter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports